export const getTaskFontWeight = (task) => {
  if (task && task?.readAt !== null && task?.readAt !== undefined) {
    return 400;
  }
  return 700;
};
